import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Constants} from "../../constants";
import {environment} from "../../environments/environment";
import {Company} from "../../models/company";
import * as moment from "moment/moment";
import {Invoice} from "../../models/invoice";

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  constructor(private http: HttpClient) {
  }

  getRequestHeaders() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': localStorage.getItem(Constants.LOCAL_TOKEN) ?? environment.publicApiToken
    });
  }

  getPublicRequestHeaders() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': environment.publicApiToken,
    });
  }

  async getInvoices(params: Record<string, string | number> = {}): Promise<{ success?: boolean; data?: any[]; count?: number }> {
    try {
      return await this.http.get<{ success?: boolean; data?: any[]; count?: number }>(
        environment.apiUrl + '/invoices',
        { params, headers: this.getRequestHeaders() }
      ).toPromise() as { success?: boolean; data?: any[]; count?: number };
    } catch (e) {
      console.error('error getInvoices: ', e);
      return { success: false, data: [], count: 0 };
    }
  }

  async getPeriodOverview(params: Record<string, string | number> = {}): Promise<{ success?: boolean; data?: any }> {
    try {
      return await this.http.get<{ success?: boolean; data?: any }>(
        environment.apiUrl + '/invoices/overview',
        { params, headers: this.getRequestHeaders() }
      ).toPromise() as { success?: boolean; data?: any };
    } catch (e) {
      console.error('error getPeriodOverview: ', e);
      return { success: false, data: undefined };
    }
  }

  async getStripeInvoiceDocument(id: string): Promise<{success?: boolean; data?: {pdfUrl: string | null; hostedUrl: string | null}}> {
    try {
      return await this.http.get<{success?: boolean; data?: {pdfUrl: string | null; hostedUrl: string | null}}>(
        environment.apiUrl + `/invoices/${id}/stripe-document`,
        {headers: this.getRequestHeaders()}
      ).toPromise() as {success?: boolean; data?: {pdfUrl: string | null; hostedUrl: string | null}};
    } catch (e) {
      console.error('error getStripeInvoiceDocument: ', e);
      return {success: false};
    }
  }

  async downloadInvoiceById(id: string) {
    let invoice: Invoice = new Invoice();
    let response: any;

    try {
      response = await this.http.get(environment.apiUrl + `/invoices/${id}`, {
        headers: this.getRequestHeaders()
      }).toPromise();

      if (response.success) {
        invoice = response.data
      }
    } catch (e) {
      console.error('error getting pendingCompanies: ', e)
    } finally {
      return invoice;
    }
  }

  async markAsPaid(id: string){

    let result: any;

    try {
      result = await this.http.put(environment.apiUrl + `/invoices/${id}/paid`, {}, {headers: this.getRequestHeaders()}).toPromise();

      return result;

    } catch (e) {
      console.error('error markAsPaid: ', e)
    }

  }

  async regenerateReport(id: string) {
    try {
      return await this.http.put(
        environment.apiUrl + `/invoices/${id}/report`,
        {},
        {headers: this.getRequestHeaders()}
      ).toPromise();
    } catch (e) {
      console.error('error regenerateReport: ', e);
      return undefined;
    }
  }

}
